import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Store } from '@/shared/store';

export const useWalletInfo = () => {
    const wallet = useSelector((state: Store) => state.wallets.active.address);
    return useMemo(() => ({ wallet }), [wallet]);
};
